export function letProto(func) {
    return func(this);
}
//# sourceMappingURL=let.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs-compat/_esm5/operator/let.js
// module id = ./node_modules/rxjs-compat/_esm5/operator/let.js
// module chunks = vendor